import React, { createContext } from "react"

// You can use this context to store static information about the current page,
// such as the location and available snippets passed from the server. This
// prevents the need for prop drilling through regions. Example:
//
//   <PageDataProvider location="campaign" snippets={snippets}>
//
// Inside a block, you can use the `usePageData` hook to access any items from
// this context. Example:
//
//   const { location, snippets } = usePageData()

export const PageDataContext = createContext({})

export function PageDataProvider({ children, ...props }) {
  return (
    <PageDataContext.Provider value={{ ...props }}>
      {children}
    </PageDataContext.Provider>
  )
}
